import React from 'react';
import { motion } from 'motion/react';
import styled from 'styled-components';
import DOMPurify from 'isomorphic-dompurify';

function Message({ type, message }) {
  return (
    <Container
      type={type}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message) }}
    />
  );
}

const Container = styled(motion.div).attrs({
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.5 }
})`
  border-radius: 4px;
  font-family: 'Inter', sans-serif;
  font-size: 0.875rem;
  margin: 1.25rem 0 -1.225rem;
  padding: 0.75rem;
  text-align: center;

  ${({ type }) =>
    type === 'success' &&
    `
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
    color: #155724;
  `}

  ${({ type }) =>
    type === 'error' &&
    `
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
    color: #721c24;
  `}
`;

export default Message;
